<template>
  <el-dialog
    :title="title"
    :visible.sync="isShow"
    :width="dialogWidth"
    :center="textAlign"
    @close="handleClose"
    :append-to-body="true"
    custom-class="myDialogClass"
    :close-on-click-modal="clickToClose"
    :show-close="showClose"
    :close-on-press-escape="closeOnPressEscape"
  >
    <template>
      <div class="body" v-scrollBar>
        <slot name="body"></slot>
      </div>
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </el-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "标题",
    },
    width: {
      type: String,
      default: "50%",
    },
    titlePos: {
      type: Boolean,
      default: true,
    },
    clickToClose: {
      type: Boolean,
      default: true,
    },
    // Esc 按钮退出
    closeOnPressEscape: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: true,
      size: "",
      dialogWidth: this.width,
      screenWid: "", //屏幕的宽度,用于调整form表单的宽度
      initSize: "",
      textAlign: true,
    };
  },
  created() {
    this.screenWid = document.documentElement.clientWidth; //1600
    // this.screenInitWid = this.screenWid   //最开始的屏幕宽度
    // console.log(this.screenWid, "init");
  },
  mounted() {
    this.$nextTick(() => {
      this.computedDialogWid(this.width); //size
      let that = this;
      window.addEventListener("resize", (e) => {
        that.screenWid = e.target.innerWidth; //获取变化后的屏幕宽度
        that.computedDialogWid();
        // console.log(that.screenWid, "resize");
      });
    });
  },
  methods: {
    //计算不同屏幕的dialog宽度
    computedDialogWid(width) {
      // this.screenInitWid  修改之前屏幕宽度
      // this.screenWid  每次修改的屏幕宽度
      // this.initSize 传值进去的原始宽度

      // 1200-1366
      switch (width) {
        case "large":
          this.size = "70%";
          break;
        case "middle":
          this.size = "50%";
          break;
        case "small":
          this.size = "30%";
          break;
        default:
          this.size = this.dialogWidth;
      }
      if (this.screenWid <= 1366 && this.screenWid >= 1200) {
        this.size = parseInt((this.toPoint(this.size) + 0.1) * this.screenWid);
        this.dialogWidth = this.size.toString();
      } else if (this.screenWid < 1200 && this.screenWid >= 1000) {
        this.size = parseInt((this.toPoint(this.size) + 0.2) * this.screenWid);
        this.dialogWidth = this.size.toString();
      } else {
        this.initSize = this.size;
        this.dialogWidth = this.size;
      }
    },
    handleClose() {
      this.$emit("handleClose");
    },
    //百分数转小数
    toPoint(percent) {
      var str = percent.replace("%", "");
      str = parseFloat(str / 100);
      // console.log(str, "toPoint");
      return str;
    },
  },
};
</script>
<style>
.myDialogClass {
  min-width: 460px;
  overflow: hidden;
}
.myDialogClass .el-dialog__body .body {
  max-height: 430px;
  position: relative;
}
.myDialogClass .el-collapse {
  border-radius: 5px 5px 0 0;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
    0 0 6px 0 rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}
.myDialogClass .el-collapse .el-collapse-item__header {
  background-color: #faecd8;
  height: 32px;
  line-height: 32px;
  border-radius: 5px 5px 0 0;
  padding-left: 20px;
  font-size: 20px;
  font-weight: 600;
}
.myDialogClass .el-collapse .el-collapse-item__header i {
  font-size: 16px;
}

.myDialogClass .el-collapse .el-collapse-item__header.is-active {
  background-color: #198acc;
  color: #f5f5f5;
}
.myDialogClass .el-collapse .el-collapse-item__content {
  padding-bottom: 0;
}

.myDialogClass .el-form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /* margin-top: 10px; */
  /* margin-right: 20px; */
}
.myDialogClass .el-form .el-form-item {
  margin-bottom: 25px !important;
  width: 90%;
}
.myDialogClass .el-form textarea {
  /* border: none; */
  /* resize: none; */
  /* margin-top: 5px; */
}

.myDialogClass .el-form--label-top .el-form-item__label {
  padding: 0;
}
/* .myDialogClass .el-form-item__label {
  line-height: 25px;
  margin: 0;
} */

.myDialogClass .el-select {
  width: 100%;
}

.myDialogClass .el-date-editor {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog-com/index.vue